import axios from 'axios';
import BaseAPI from './base/base-api';

class DashboardAPI extends BaseAPI {
    constructor() {
        super();
    }
    urlName = 'InvoiceBotsAPI';
    controllerName = 'dashboards';

}

export default new DashboardAPI();